import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import ColoringPageButton from "../../../../atoms/ColoringPageButton";
import SubmitAnswerButton from "../../../../atoms/SubmitAnswerButton";
import { StoreContext } from "../../../../../contexts";
import {
  getDetails,
  getURL,
} from "../../../Library/components/Project/components/Preview/utilities";
import { resolveAndPlay } from "../../../../../utilities/secureVideo";
import { APPLICATION_ROUTES } from "../../../../../constants";
import {  AuthorizationKids, AuthorizationCommon } from "../../../../organisms/RestrictionModal/RestrictionModal";
import { useModal } from "../../../../../hooks";
import cs from "classnames";
import classes from "./VideoButtons.module.scss";

const VideoButtons = observer(
  ({
    locales,
    categories,
    questions,
    tags,
    file,
    holiday,
    internal_id,
    onSelect,
    videoAction,
  }) => {
    const { playlist, authorization, partnership } = useContext(StoreContext);
    const popup = useModal();
    const popupKids = useModal();

    const submitAnswer = (e) => {
      playlist.setCurrentPlayingVideoId(details.id);
      resolveAndPlay({
        details,
        onSelect,
        buildPayload: (resolvedLink) => ({
          end: details.end_time,
          start: details.start_time,
          url: getURL(resolvedLink, { start: details.start_time }),
          name: details.name,
          description: details.description,
          number: details.number,
          categories: categories,
          questions: questions,
          tags: tags,
          holiday: holiday,
          date: details.created_at,
          file: file,
        }),
        on401: () => popup.onOpen(),
        on403: () => popupKids.onOpen(),
      });
      videoAction.showQuestionScreen(e);
    };

    // const sharePage = async () => {
    //   try {
    //     await navigator.share({
    //       url: window.location.origin + "/" + details.video_url,
    //       title: details.title,
    //     });
    //   } catch (e) {
    //     console.error(e);
    //   }
    // };

    const details = getDetails("en", locales);

    const downloadFile = (url) => {
      window.open(url);
    };

    const pdfHandler = () => {
      if (authorization.isAuthenticated) {
        downloadFile(file);
      } else {
        if (!location.pathname.includes(APPLICATION_ROUTES.LIBRARY_PROECTED)) {
          playlist.setCurrentPlayingVideoId(details.id);
          resolveAndPlay({
            details,
            onSelect,
            buildPayload: (resolvedLink) => ({
              end: details.end_time,
              start: details.start_time,
              url: getURL(resolvedLink, {
                start: details.start_time,
              }),
              name: details.name,
              description: details.description,
              number: details.number,
              categories: categories,
              questions: questions,
              tags: tags,
              holiday: holiday,
              date: details.created_at,
              file: details.file,
              internal_id: internal_id,
            }),
            on401: () => popup.onOpen(),
            on403: () => popupKids.onOpen(),
          });
        }
      }
    };

    return (
      <div className={cs(classes.previewButtons)}>
        {file && <ColoringPageButton pdfHandler={pdfHandler} />}
        <SubmitAnswerButton submitAnswer={submitAnswer} />

        {/* <Authorization
          popup={popup}
          authorization={authorization}
          partnership={partnership}
        /> */}
        <AuthorizationKids
          popup={popup}
          authorization={authorization}
          partnership={partnership}
        />
        <AuthorizationCommon
          popup={popupKids}
          authorization={authorization}
          partnership={partnership}
        />
      </div>
    );
  }
);

export default VideoButtons;
